import styled from 'styled-components';
import { SampleTypes } from 'Widgets/Chart/LegendSample';
import { DVColors } from 'Widgets/ColorSchemes';
export var TotalAnomalyDisplayOptionsEnum;
(function (TotalAnomalyDisplayOptionsEnum) {
    TotalAnomalyDisplayOptionsEnum["AreaExtremes"] = "Area_extremes";
    TotalAnomalyDisplayOptionsEnum["SyncTooltips"] = "Sync_tooltips";
    TotalAnomalyDisplayOptionsEnum["ImputedData"] = "Imputed_data";
})(TotalAnomalyDisplayOptionsEnum || (TotalAnomalyDisplayOptionsEnum = {}));
export const TOTAL_ANOMALY_DISPLAY_OPTIONS = {
    [TotalAnomalyDisplayOptionsEnum.AreaExtremes]: {
        isEnabled: true,
        text: 'Extrema'
    },
    [TotalAnomalyDisplayOptionsEnum.SyncTooltips]: {
        isEnabled: true,
        text: 'Sync Tooltips'
    },
    [TotalAnomalyDisplayOptionsEnum.ImputedData]: {
        isEnabled: true,
        text: 'Imputed Data'
    }
};
const Panel = styled.div `
  padding-top: 16px;
  min-height: 500px;
  z-index: 10000;
`;
export { Panel };
const ALARM_LABEL = 'Alarm Period';
const EVENT_LABEL = 'Event';
export const HIGHLIGHTS_LEGEND_DATA_SAMPLES = {
    child: {
        label: `${ALARM_LABEL}s`,
        labelsByColors: {
            [DVColors.OrphanAlerts]: `New ${ALARM_LABEL}`,
            [DVColors.ArchivedPeriods]: `Archived ${ALARM_LABEL}`,
            [DVColors.Periods]: `Unarchived ${ALARM_LABEL}`
        },
        sampleType: SampleTypes.BOX_FRAMED
    },
    parent: {
        label: `${EVENT_LABEL}s`,
        labelsByColors: {
            [DVColors.ArchivedPeriods]: `Archived ${EVENT_LABEL}`,
            [DVColors.Periods]: `Unarchived ${EVENT_LABEL}`
        },
        sampleType: SampleTypes.BOX_FRAMED_OBLONG
    },
    timeline: {
        label: 'Total Anomaly',
        sampleType: SampleTypes.LINE_SHADOWED
    }
};
export const getMultiModelsHighlightsLegendDataSamples = (colorsToLabels) => {
    if (!colorsToLabels)
        return HIGHLIGHTS_LEGEND_DATA_SAMPLES;
    const colors = Object.keys(colorsToLabels);
    if (!colors.length)
        return HIGHLIGHTS_LEGEND_DATA_SAMPLES;
    return colors.reduce((acc, color) => {
        const modelLabel = colorsToLabels[color];
        return {
            ...acc,
            child: {
                ...acc.child,
                labelsByColors: {
                    ...acc.child?.labelsByColors,
                    [color]: `${ALARM_LABEL}s of ${modelLabel}`
                }
            },
            parent: {
                ...acc.parent,
                labelsByColors: {
                    ...acc.parent?.labelsByColors,
                    [color]: `${EVENT_LABEL} of ${modelLabel}`
                }
            }
        };
    }, {
        child: {
            label: `${ALARM_LABEL}s`,
            labelsByColors: {},
            sampleType: SampleTypes.BOX_FRAMED
        },
        parent: {
            label: `${EVENT_LABEL}s`,
            labelsByColors: {},
            sampleType: SampleTypes.BOX_FRAMED_OBLONG
        },
        timeline: {
            label: 'Total Anomaly',
            sampleType: SampleTypes.LINE_SHADOWED
        }
    });
};
